import Modal from "bootstrap/js/dist/modal";
// Define this object for external usage of Bootstrap 5 Modal instance
window.Modal = Modal;
export function areModalsClosed() {
    const openModals = document.querySelectorAll(".modal.show").length;
    return openModals === 0;
}
export function isModalShown(modalElement) {
    return modalElement.classList.contains("show");
}
export function showModal(modalElement) {
    Modal.getOrCreateInstance(modalElement).show();
}
export function hideModal(modalElement) {
    Modal.getOrCreateInstance(modalElement).hide();
}
/**
 * Modals that have started hiding (hide.bs.modal) but not yet finished (hidden.bs.modal).
 * Used by waitForPendingHides to sequence show animations after hide animations complete.
 */
const pendingHideIds = new Set();
/**
 * Returns a promise that resolves once all currently-hiding modals have finished
 * their hide animations.
 */
export function waitForPendingHides() {
    return new Promise((resolve) => {
        // Uses setTimeout to make it work with immediate show -> hide
        setTimeout(() => {
            if (pendingHideIds.size === 0) {
                resolve();
                return;
            }
            const promises = [...pendingHideIds].map((id) => new Promise((res) => {
                const el = document.getElementById(id);
                if (!el) {
                    res();
                    return;
                }
                el.addEventListener("hidden.bs.modal", () => res(), { once: true });
            }));
            void Promise.all(promises).then(() => resolve());
        }, 0);
    });
}
// e2e synchronization — tracks in-flight show/hide operations so test runners
// can wait for animations to settle before asserting on the DOM.
const addTask = "__addTask__" in window
    ? window.__addTask__
    : () => { };
const doneTask = "__doneTask__" in window
    ? window.__doneTask__
    : () => { };
/**
 * Attach document-level listeners needed by Bootstrap modals:
 *   - e2e task tracking (show/shown/hide/hidden)
 *   - pendingHideIds tracking (for show/hide sequencing)
 *   - sequential modal body class fix
 */
function initModalListeners() {
    document.addEventListener("show.bs.modal", (e) => {
        addTask(`Modals:show ${e.target.id}`);
    });
    document.addEventListener("shown.bs.modal", (e) => {
        var _a;
        doneTask(`Modals:show ${e.target.id}`);
        // Ensure modal-open body class is present when opening one modal from
        // within another (sequential modals where event order is hide→show→hidden→shown).
        if (!areModalsClosed()) {
            (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.add("modal-open");
        }
    });
    document.addEventListener("hide.bs.modal", (e) => {
        const id = e.target.id;
        pendingHideIds.add(id);
        addTask(`Modals:hide ${id}`);
    });
    document.addEventListener("hidden.bs.modal", (e) => {
        const id = e.target.id;
        pendingHideIds.delete(id);
        doneTask(`Modals:hide ${id}`);
    });
}
export default {
    init: function () {
        initModalListeners();
    },
};
